import React from 'react';

import { cn } from '@/lib/utils';
import {
  TAG_BADGE_CLASS_NAME,
  normalizeTagList,
} from '@/Modules/Core/Components/Tags/tagUtils';

const TagBadgeList = ({
  tags,
  className,
  emptyLabel = 'No tags',
  maxVisible,
  onOverflowClick,
}) => {
  const normalizedTags = React.useMemo(() => normalizeTagList(tags), [tags]);

  if (normalizedTags.length === 0) {
    return (
      <span className={cn('text-[12px] text-muted-foreground', className)}>
        {emptyLabel}
      </span>
    );
  }

  const visibleTags =
    Number.isFinite(maxVisible) && maxVisible > 0
      ? normalizedTags.slice(0, maxVisible)
      : normalizedTags;
  const hiddenCount = normalizedTags.length - visibleTags.length;

  return (
    <div className={cn('flex flex-wrap items-center gap-1.5', className)}>
      {visibleTags.map((tag) => (
        <span key={tag.value} className={TAG_BADGE_CLASS_NAME} title={tag.label}>
          <span className="truncate">{tag.label}</span>
        </span>
      ))}

      {hiddenCount > 0 ? (
        <button
          type="button"
          onClick={onOverflowClick}
          className={cn(
            TAG_BADGE_CLASS_NAME,
            'border-dashed bg-background/80 text-muted-foreground transition-colors hover:text-foreground'
          )}
        >
          +{hiddenCount} more
        </button>
      ) : null}
    </div>
  );
};

export default TagBadgeList;
